import SidebarComponentView from './SidebarComponent.view';
export * from './SidebarComponent.view';

export const SidebarComponent = (props) => SidebarComponentView(props);

export default SidebarComponent;

